import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountInformationCentreService } from './account-information-centre.service';

@NgModule({
    imports: [CommonModule],
    providers: [AccountInformationCentreService]
})
export class AccountInformationCentreModule {
    constructor(private informationCentreService: AccountInformationCentreService) {}
}
